export class TotalPriceResult {
    pricePeriod: number;
    pricePeriodDisplay: string;
    priceAnnual: number;
    priceAnnualDisplay: string;
    missingCalculations: string[] = [];
}
